import React from "react";
import { motion } from "framer-motion";
import { Card } from "../commons/UI";
import { listServices } from "../../web/clients";

export const ServiceGrid = ({ items, minimal = false }: { items?: Array<any>; minimal: boolean }) => {
  const [data, setData] = React.useState(items || null);

  React.useEffect(() => {
    if (!items) listServices().then(setData);
  }, [items]);

  return (
    <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {(data || []).map((s) => (
        <motion.div key={s.id} initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <Card className="h-full">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2 text-indigo-200">
                {s.icon}
                <h3 className="font-semibold text-slate-100">{s.title}</h3>
              </div>
              {s.tag && (
                <span className="text-[10px] uppercase tracking-wider text-indigo-200/80 border border-indigo-400/20 rounded-full px-2 py-1 bg-indigo-500/10">
                  {s.tag}
                </span>
              )}
            </div>
            <p className="text-slate-300 mt-2 text-sm">{s.desc}</p>
            {!minimal && (
              <ul className="mt-3 space-y-1 text-sm text-slate-300 list-disc list-inside">
                {(s.bullets as Array<any>).map((b, i) => (<li key={i}>{b}</li>))}
              </ul>
            )}
          </Card>
        </motion.div>
      ))}
    </div>
  );
};
